import { createApp, h } from 'vue'
import { app as mainApp } from '@/main'
import { usePopupState } from '@/composables/usePopupState'

/**
 * Mount a component to DOM with shared app context (i18n, pinia, router, etc.)
 * Uses app.runWithContext() to ensure the component has access to all app plugins
 */
export function mountComponent(RootComponent, props = {}) {
  const subApp = createApp(RootComponent, props)
  // 关键：同步主应用的所有全局配置、组件、指令和插件
  Object.assign(subApp._context, mainApp._context)

  const root = document.createElement('div')
  document.body.appendChild(root)

  let instance;

  // 同步 provide/inject 和 全局属性
  mainApp.runWithContext(() => {
    instance = subApp.mount(root)
  })

  return {
    instance,
    unmount() {
      subApp.unmount()
      document.body.removeChild(root)
    },
  }
}

/**
 * Create a singleton component instance for function-style modal/popup
 * @param {Component} Component - Vue component to instantiate
 * @returns {Object} instance - Component instance with open/close/toggle methods
 */
export function createComponentInstance(Component) {
  const Wrapper = {
    setup() {
      const { state, toggle } = usePopupState()

      return () =>
        h(Component, {
          ...state,
          'onUpdate:show': toggle,
        })
    },
  }

  const { instance, unmount } = mountComponent(Wrapper)
  instance.unmount = unmount
  return instance
}
